/**
 * Formats a time in seconds to a string in the format "MM:SS"
 *
 * @param {number} time
 * @return {*}
 */
export const formatAudioTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};
